import { InferActionsTypes } from "./../index";
import { UpdateVisitor } from "../../../types/reducers/routesReducer";

export const actionTypes = {
  GET_TEAM: "GET_TEAM",
  GET_TEAM_SUCCESS: "GET_TEAM_SUCCESS",
  DELETE_TEAM_TRIGGER: "ВELETE_TEAM_TRIGGER",
  UPDATE_VISITOR_TRIGER: "UPDATE_VISITOR_TRIGER",
  UPDATE_VISITOR_SUCCESS: "UPDATE_VISITOR_SUCCESS",
  UPDATE_VISITOR_ERROR: "UPDATE_VISITOR_ERROR",
  RESEND_LOGIN_LINK_TRIGGER: "RESEND_LOGIN_LINK_TRIGGER",
  RESEND_LOGIN_LINK_SUCCESS: "RESEND_LOGIN_LINK_SUCCESS",
};

type InitialState = {
  team: null;
};

const initialState: InitialState = {
  team: null,
};

export const teamReducer = (state = initialState, action: Actions) => {
  switch (action.type) {
    case actionTypes.GET_TEAM:
      return {
        ...state,
    };

    case actionTypes.GET_TEAM_SUCCESS:
      return {
        ...state,
        team: action.payload,
      };

    default:
      return state;
  }
};

export const actions = {
  getTeamAC: (data: any) => ({
    type: actionTypes.GET_TEAM,
    payload: data,
  }),
};

export const teamTriggerActions = {
  getTeamTriggerAC: (searchValue: string | null, currentPage: number, perPageValue: string) => ({
    type: actionTypes.GET_TEAM,
    searchValue,
    page: currentPage,
    perPage: perPageValue
  }),

  updateVisitorTriggerAC: (data: UpdateVisitor) => ({
    type: actionTypes.UPDATE_VISITOR_TRIGER,
    data,
  }),

  deleteTeamTriggerAC: (id: string) => ({
    type: actionTypes.DELETE_TEAM_TRIGGER,
    id,
  }),

  resendLoginLinkTriggerAC: (id: string) => ({
    type: actionTypes.RESEND_LOGIN_LINK_TRIGGER,
    id,
  }),
};

export type Actions = InferActionsTypes<typeof actions>;
